import SpriteSymbol from "../../../../../../wx-ktv-build/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../wx-ktv-build/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-agreement-select",
  "use": "icon-agreement-select-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-agreement-select\">\n<circle cx=\"12\" cy=\"12\" r=\"11\" stroke=\"currentColor\" stroke-opacity=\"0.4\" stroke-width=\"2\" />\n<circle cx=\"12\" cy=\"12\" r=\"8\" fill=\"currentColor\" fill-opacity=\"0.4\" />\n<circle cx=\"12\" cy=\"12\" r=\"7.2\" stroke=\"currentColor\" stroke-opacity=\"0.4\" stroke-width=\"1.6\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol